export default function isEmailValid(email: string) {
  if (!email || !/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(email)) {
    return false;
  }
  return true;
}
